import api from '../api'

export interface Appointment {
  id: number
  customer_id: number
  team_member_id: number
  skill_id: number
  date: string
  start_time: string
  end_time: string
  status: string
  notes?: string
  completed_notes?: string
  cancelled_notes?: string
  created_by_id: number
  customer: {
    id: number
    name: string
    email?: string
    phone?: string
  }
  team_member: {
    id: number
    user: {
      id: number
      email: string
      first_name?: string
      last_name?: string
      full_name?: string
    }
  }
  skill: {
    id: number
    name: string
    category: string
  }
  creator: {
    id: number
    email: string
  }
}

interface AppointmentFormData {
  customer_id: number
  team_member_id: number
  skill_id: number
  date: string
  start_time: string
  end_time: string
  notes?: string
  status?: string
}

interface TimeSlot {
  id: number
  start_time: string
  end_time: string
}

export const appointmentsApi = {
  // Get all appointments
  getAll: async (params?: { start_date?: string; end_date?: string; date?: string; team_member_id?: number; customer_id?: number; status?: string }) => {
    const response = await api.get<{ appointments: Appointment[] }>('/appointments', { params })
    return response.data
  },

  // Get single appointment
  get: async (id: number) => {
    const response = await api.get<{ appointment: Appointment }>(`/appointments/${id}`)
    return response.data
  },

  // Create appointment
  create: async (data: AppointmentFormData) => {
    const response = await api.post<{ appointment: Appointment; message: string }>('/appointments', { appointment: data })
    return response.data
  },

  // Update appointment
  update: async (id: number, data: Partial<AppointmentFormData>) => {
    const response = await api.put<{ appointment: Appointment; message: string }>(`/appointments/${id}`, { appointment: data })
    return response.data
  },

  // Delete appointment
  delete: async (id: number) => {
    await api.delete(`/appointments/${id}`)
  },

  // Get availability for a team member on a specific date
  getAvailability: async (teamMemberId: number, date: string) => {
    const response = await api.get<{ date: string; team_member_id: number; booked_slots: TimeSlot[] }>('/appointments/availability', {
      params: { team_member_id: teamMemberId, date }
    })
    return response.data
  },

  // Update appointment status
  updateStatus: async (id: number, status: string) => {
    const response = await api.patch<{ appointment: { id: number; status: string }; message: string }>(`/appointments/${id}/update_status`, { status })
    return response.data
  },
}
